module.exports = __webpack_public_path__ + "static/media/cor.f434cbe0.jpeg";